import { memo } from 'react';

import { cn } from '../../../lib/cn';

interface LinkCellProps {
  value: string | null | undefined;
  href?: string;
  className?: string;
}

export const LinkCell = memo(function LinkCell({
  value,
  href,
  className,
}: LinkCellProps) {
  if (!value) {
    return <span className="text-slate-400">-</span>;
  }

  const resolvedHref = href ?? (value.includes('@') ? `mailto:${value}` : value);

  return (
    <a
      href={resolvedHref}
      onClick={(e) => e.stopPropagation()}
      className={cn(
        'text-sm text-primary-500 hover:text-primary-600 hover:underline transition-colors',
        className,
      )}
    >
      {value}
    </a>
  );
});
